<template>
  <div>
    <section class="section-title-page container-fluid" style="background-image: url('img/bg_tramite.jpg')">
      <div class="container">
        <div class="wrapper">
          <h1>
            Trámite <small style="font-weight: 300">{{ Tramite.titulo }}</small>
          </h1>
          <span>
            Volver <i class="fa fa-angle-right mx-1"></i>
            <a href="/Tramites/">Trámites</a>
          </span>
        </div>
      </div>
    </section>

    <section class="section-page">
      <div class="container process-selected p-0">
        <div class="col p-0 d-flex">
          <div class="col-md-9">
            <h2 class="title">Requisitos</h2>
            <div class="context">
              <table class="table">
                <tbody>
                  <tr v-for="(value, key) in Requisitos" :key="key">
                    <td>
                      {{ value.requisito }}<br />
                      <small class="text-muted">{{ value.nota }}</small>
                    </td>
                    <td class="text-center">
                      <a v-if="value.archivo" class="download" :title="value.requisito" href="javascript:void(0)" @click="downloadItem(base_url+'ws_cors/download?file='+value.archivo+'&dir=requisito_tramite', value.file)">
                        <i class="fa fas fa-download"></i>
                      </a>
                      <strong v-else class="text-muted font-italic" style="font-weight: 400;">Sin formato</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-3">
            <h2 class="title bg-brown text-white">COSTO</h2>
            <div class="context bg-white">
              <h6 class="font-weight-bold mb-0 text-dark">{{ Derecho_pago }}</h6>
            </div>
            <h2 class="title bg-gray text-white">OTROS TRÁMITES</h2>
            <div>
              <ul class="ul-process pl-3">
                <li v-for="(value, k) in ListaTramites" :key="k">
                  <a :href="'/tramite/' + value.id"><i :class="['fa-solid', 'fa-circle']"></i>{{ value.titulo }} {{
                    value.subtitulo }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Tramites from "./Tramites.vue";

export default {
  name: "tramite",
  computed: {
    ...mapState(["empresa"]),
  },
  created() { },
  mounted() {
    this.getTramite(),
      this.getTramites();
  },
  data() {
    return {
      id: this.$route.params.id ? this.$route.params.id : "-",
      Tramite: {},
      Requisitos: [],
      Derecho_pago: [],
      ListaTramites: [],
      base_url: `${window.baseUrl}`,
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getTramite() {
      this.setLoading(true);
      this.$http.get("ws_process/get_process?id=" + this.id).then((res) => {
        this.Tramite      = res.data.Tramite;
        this.Requisitos   = res.data.Tramite.requisitos;
        this.Derecho_pago = res.data.Tramite.derecho_pago;
        this.setLoading(false);
      });
    },
    getTramites() {
      this.setLoading(true);
      this.$http.get("ws_principal/process").then((res) => {
        this.ListaTramites = res.data.Tramites;
        this.setLoading(false);
      });
    },
  },
};
</script>